var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"sticky top-0 z-10 bg-white"},[_c('Topbar')],1),_c('div',{staticClass:"m-4 mt-6"},[_c('div',{staticClass:"mx-auto max-w-2xl"},[_c('Form')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }